import { render, staticRenderFns } from "./FooterLinkForm.vue?vue&type=template&id=cbc3f9b6&scoped=true&"
import script from "./FooterLinkForm.vue?vue&type=script&lang=js&"
export * from "./FooterLinkForm.vue?vue&type=script&lang=js&"
import style0 from "./FooterLinkForm.vue?vue&type=style&index=0&id=cbc3f9b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc3f9b6",
  null
  
)

export default component.exports